module.exports = __webpack_public_path__ + "static/img/3s-info-b3.645d7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-b3.jpg
// module id = ADrp
// module chunks = 0